import { PriceAnswerResponse, PriceResponderListResponse, PriceResponderPreviewResponse, PriceResponderSummary, ResponderExclusionListResponse, ResponderLogResponse, } from '@aeris/contracts';
import { request } from "./client.js";
const base = '/api/v1/communication/price-responders';
export const fetchPriceResponders = async (signal) => PriceResponderListResponse.parse(await request(base, { signal })).responders;
export const savePriceResponder = async (accountId, body) => PriceResponderSummary.parse(await request(`${base}/${accountId}`, { method: 'PUT', body }));
/** A caixa de teste: com `draft`, testa o que está na tela sem gravar. */
export const previewPriceResponder = async (accountId, message, draft) => PriceResponderPreviewResponse.parse(await request(`${base}/${accountId}/preview`, {
    method: 'POST',
    body: draft === undefined ? { message } : { message, draft },
}));
export const fetchResponderExclusions = async (accountId, signal) => ResponderExclusionListResponse.parse(await request(`${base}/${accountId}/exclusions`, { signal })).exclusions;
export const addResponderExclusion = async (accountId, productId) => ResponderExclusionListResponse.parse(await request(`${base}/${accountId}/exclusions`, {
    method: 'POST',
    body: { productId },
})).exclusions;
export const removeResponderExclusion = async (accountId, productId) => ResponderExclusionListResponse.parse(await request(`${base}/${accountId}/exclusions/${productId}`, {
    method: 'DELETE',
})).exclusions;
export const fetchResponderLog = async (accountId, before, signal) => ResponderLogResponse.parse(await request(`${base}/${accountId}/log${before === null ? '' : `?before=${before}`}`, { signal }));
/**
 * A resposta do robô para o vendedor copiar (F345), com
 * `communication.message.send`: nada é enviado.
 */
export const fetchPriceAnswer = async (message) => PriceAnswerResponse.parse(await request('/api/v1/communication/price-answer', {
    method: 'POST',
    body: { message },
}));
//# sourceMappingURL=communication-price-responder.js.map